import React, { useEffect } from 'react'

export default function CookiePage() {
  const title = "Cookie | Malerfirmaet Villy Poulsen"
  const metaDesc = "Information om brug af cookies på denne hjemmeside."

  useEffect(() => {
    document.title = title
    const metaDescriptionTag = document.querySelector('meta[name="description"]')
    if (metaDescriptionTag) {
      metaDescriptionTag.setAttribute('content', metaDesc)
    }
  }, [])

  return (
    <div className="bg-white py-20">
      <div className="max-w-4xl mx-auto px-4 sm:px-6">
        <span className="text-xs font-bold uppercase tracking-widest text-[#01529E] bg-[#01529E]/5 px-3 py-1.5 rounded-full">
          Privatlivspolitik
        </span>
        <h1 className="text-3xl sm:text-4xl font-black text-gray-900 mt-4 mb-2">Cookie</h1>
        <p className="text-gray-500 text-sm font-semibold mb-10">
          Information om brug af cookies på denne hjemmeside
        </p>

        <div className="prose max-w-none prose-red text-gray-600 space-y-8">
          <p className="text-lg leading-relaxed font-medium text-gray-700">
            Ved at benytte denne hjemmeside accepterer du, at vi bruger cookies.
          </p>

          <div>
            <h2 className="text-xl font-bold text-gray-900 mb-3">Hvad er en cookie?</h2>
            <p className="leading-relaxed">
              Cookies er små tekstfiler, der gemmes i din browser, så vi kan se, at din computer, smartphone, iPad eller lignende har besøgt denne hjemmeside.
            </p>
            <p className="leading-relaxed mt-2">
              Disse cookies kan have mange forskelligartede formål og kan eksempelvis bruges til at huske præferencer og føre statistik over dit besøg og andre besøgende.
            </p>
          </div>

          <div>
            <h2 className="text-xl font-bold text-gray-900 mb-3">Oversigt over hjemmesidens brug af cookies</h2>
            
            <div className="space-y-6 mt-4">
              <div className="bg-gray-50 p-6 rounded-xl border border-gray-100">
                <h3 className="text-base font-bold text-gray-900 mb-2">Cookies som er nødvendige</h3>
                <p className="text-sm leading-relaxed">
                  Visse typer cookies er nødvendige for at denne hjemmeside kan levere fx en tjeneste, som du udtrykkeligt har anmodet om. Det kunne eksempelvis være et login.
                </p>
              </div>

              <div className="bg-gray-50 p-6 rounded-xl border border-gray-100">
                <h3 className="text-base font-bold text-gray-900 mb-2">Cookies til dine præferencer</h3>
                <p className="text-sm leading-relaxed">
                  Disse typer cookies skal sørge for, at du får den bedst tænkelige oplevelse her på hjemmesiden. Det kan være cookies, som husker din navigation på siden, valg i bokse og lignende. Intet af denne indsamlede information kan identificere dig personligt.
                </p>
              </div>

              <div className="bg-gray-50 p-6 rounded-xl border border-gray-100">
                <h3 className="text-base font-bold text-gray-900 mb-2">Cookies for optimering og løbende drift</h3>
                <p className="text-sm leading-relaxed">
                  Disse typer cookies anvendes eksempelvis til at samle statistik om trafik til og fra hjemmesiden. Kun i begrænset omfang kan disse data identificere dig som bruger. Der bliver dog ikke gjort brug af disse data i forhold til den enkelte bruger.
                </p>
                <p className="text-sm leading-relaxed mt-2">
                  Blandt andet anvendes dataene her i forbindelse med vores brug af Google Analytics, MetaTraffic eller andre analyseprogrammer. Disse oplysninger går til servere, som kan være placeret i både Danmark og udlandet. Du kan fravælge cookies fra Google Analytics her:{' '}
                  <a 
                    href="http://tools.google.com/dlpage/gaoptout" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="text-[#01529E] hover:underline font-semibold"
                  >
                    http://tools.google.com/dlpage/gaoptout
                  </a>
                </p>
              </div>
            </div>
          </div>

          <div>
            <h2 className="text-xl font-bold text-gray-900 mb-3">Sådan afviser du cookies</h2>
            <p className="leading-relaxed">
              Ved at ændre indstillingerne i din browser, kan du afvise cookies på din computer. Hvordan du ændrer indstillingerne i din browser afhænger af, hvilken browser du anvender. Vælger du at indstille din browser, så du ikke modtager cookies, skal du være opmærksom på, at du kan gå glip af funktioner og lignende på hjemmesiden, som i så fald ikke vil fungere.
            </p>
          </div>

          <div>
            <h2 className="text-xl font-bold text-gray-900 mb-3">Sådan slettes du dine cookies</h2>
            <p className="leading-relaxed">
              Hvis du tidligere har accepteret cookies, kan disse også slettes. Det gør du ligeledes i indstillingerne af din webbrowser.
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}
